import * as React from 'react';

import { EFieldGroupName, EFieldName } from '../../../../types/field';
import { CommonRowContainer } from './common';

export interface ITableRowContainerProps {
  dragging?: boolean;
  groupName: EFieldGroupName;
  name: EFieldName;
  position: number;
  title?: string | null;
  rowRef?: React.Ref<HTMLTableRowElement>;
}

export const TableRowContainer = ({ dragging, name, title, position, groupName, rowRef }: ITableRowContainerProps) => {
  switch (name) {
    default:
      return (
        <CommonRowContainer
          rowRef={rowRef}
          groupName={groupName}
          position={position}
          name={name}
          title={title}
          dragging={dragging}
        />
      );
  }
};
